'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive("saisieCoucheAdditionnelle", function () {
  return {
    restrict: "E",
    replace: true,
    template: require("./saisieCoucheAdditionnelle.html"),
    link: function link($scope, $el, $attrs) {},
    controller: function controller($scope, $q, $http, $modal, $compile, $session, budgetService, contextService, $dialogBox, coucheAdditionnelleService, tlTableUtils, $notifications) {
      var urlRoot = '/rest/saisie/couche-additionnelle';
      var load = function load() {
        $http.get(urlRoot + "/list").then(function (response) {
          $scope.coucheAdditionnelles = response.data;
          $scope.selectedCoucheAdditionnelle = tlTableUtils.getNewTableSelection($scope.selectedCoucheAdditionnelle, $scope.coucheAdditionnelles);
          if ($scope.selectedCoucheAdditionnelle == null && $scope.coucheAdditionnelles.length > 0) {
            // idealement ce serait plutôt la première ligne du tableau (peu importe les tris) qu'on voudrait voir sélectionnée
            $scope.selectedCoucheAdditionnelle = $scope.coucheAdditionnelles[0];
          }
        });
      };
      tlTableUtils.fixResize($scope, 'coucheAdditionnelles');
      tlTableUtils.fixResize($scope, 'selectedCoucheAdditionnelle');
      $scope.coucheAdditionnellesTableConfig = {
        source: "coucheAdditionnelles",
        selectionScope: $scope,
        allowSelection: true,
        selectionAttribute: "selectedCoucheAdditionnelle",
        initialSort: ["nom", "asc"],
        columns: [{
          title: "Nom",
          attribute: 'nom',
          template: '{{model.nom}}' + '<i ng-if="model.editable==false" class="fa fa-chevron-circle-up blue ml-m" ' + 'tl-tooltip="Cette couche additionnelle est définie sur le compte \'{{model.compteNomClient}}\' et ne peut être modifiée que sur ce compte."></i>',
          sortable: true,
          sortType: 'alphanum'
        }, {
          template: '<tl-icon-button ng-if="model.editable" authz-if-role="SAISIE" icon="edit" tl-tooltip="Editer" ng-click="editCoucheAdditionnelle(model)"></tl-icon-button>' + '<tl-icon-button ng-if="model.editable" authz-if-role="SAISIE" icon="delete" tl-tooltip="Supprimer" ng-click="deleteCoucheAdditionnelle(model)"></tl-icon-button>',
          width: '100px',
          cellClass: 'align-c'
        }]
      };
      $scope.addCoucheAdditionnelle = function () {
        coucheAdditionnelleService.openCreationPopin().then(function (response) {
          // pour permettre de sélectionner la coucheAdditionnelle créée
          $scope.selectedCoucheAdditionnelle = {
            id: response.id
          };
          load();
        });
      };
      $scope.editCoucheAdditionnelle = function (coucheAdditionnelle) {
        coucheAdditionnelleService.openEditionPopin(coucheAdditionnelle).then(function (response) {
          load();
        });
      };
      $scope.deleteCoucheAdditionnelle = function (coucheAdditionnelle) {
        $dialogBox.confirm({
          title: "Suppression d'une couche additionnelle",
          text: "Êtes-vous sûr de vouloir supprimer la couche additionnelle '" + coucheAdditionnelle.nom + "' ?"
        }).then(function () {
          coucheAdditionnelleService.delete(coucheAdditionnelle.id).then(function (response) {
            if (response.valid) {
              $notifications.info("Couche additionnelle " + coucheAdditionnelle.nom + " supprimée.");
              load();
            }
          });
        });
      };
      load();
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/coucheAdditionnelle/saisieCoucheAdditionnelle.js
// module id = 2771
// module chunks = 13